import { designThemeIcon } from '@services/MarppleShop/shared/components/atoms/Icon/foundation_icons.ts';
import { html } from 'fxjs/es';
import { UtilS } from '../../../../Util/S/Function/module/UtilS.js';
import { ACTION, ACTION_TARGET, SERVICE } from '../../../Authority/S/constant.js';
import { isNotCategoryOutsourceManagerByCrew, isAllCrew, isAllOrMarppleCrewById } from '../../S/util.js';
import { CREW_STORE_MENU_TYPE } from '../../StoreManagement/S/constant.js';
import { ADMIN_LNB_MENU_ID } from '@modules/Creator/Crew/MenuNav/S/lnb-data.ts';
import { isNil } from '@fxts/core';

export const SELLER_MANAGEMENT_MENU = {
  path: `stores/list?type=${encodeURIComponent(CREW_STORE_MENU_TYPE.ACTIVE)}`,
  name: T('crew_menu::seller_management'),
  icon_html: html` <i class="d-block lnr lnr-user small"></i> `,
};

export const CREATOR_IN_REVIEW_MENU = (count) => ({
  path: `stores/list?type=${encodeURIComponent(CREW_STORE_MENU_TYPE.DISAPPROVAL)}`,
  name: html`${T('crew_menu::creator_in_review')}
  ${isNil(count) ? '' : html`<span class="menu_count">${count}</span>`}`,
  icon_html: html` <i class="d-block lnr lnr-user small"></i> `,
  filter: (crew) => isNotCategoryOutsourceManagerByCrew(crew) && isAllCrew(crew),
});

export const MANAGER_MANAGEMENT_MENU = {
  path: 'managers',
  name: T('crew_menu::manager_management'),
  icon_html: html` <i class="d-block lnr lnr-users big"></i> `,
  action_option: {
    actions: ACTION.UPDATE_MANAGER_LEVEL,
    target: ACTION_TARGET.CREW,
  },
};
export const SELLER_WITHDRAW_MENU = {
  path: 'withdraw',
  name: T('crew_menu::seller_adjustment'),
  icon_html: html` <i class="d-block lnr lnr-database"></i> `,
  action_option: {
    actions: ACTION.READ_WITHDRAWS,
    target: ACTION_TARGET.CREW,
    service: SERVICE.WITHDRAW,
    pass_no_service: false,
  },
  filter: (crew) => {
    return isAllOrMarppleCrewById(crew.id);
  },
};

export const PROFIT_MENU = {
  path: 'profit',
  name: T('plus_admin::pa97'),
  icon_html: html` <i class="d-block lnr lnr-chart-bars"></i> `,
  action_option: {
    actions: ACTION.READ_SALES_AMOUNT,
    target: ACTION_TARGET.CREW,
  },
  sub_menus: [
    {
      path: 'mps/daily',
      name: T('crew_menu::store_profit'),
      icon_html: html` <i class="d-block lnr lnr-chart-bars"></i> `,
    },
    {
      path: 'pbg/daily',
      name: T('crew_menu::store_seller_profit'),
      icon_html: html` <i class="d-block lnr lnr-chart-bars"></i> `,
    },
    {
      path: 'tpl/daily',
      name: T('crew_menu::store_tpl_profit'),
      icon_html: html` <i class="d-block lnr lnr-chart-bars"></i> `,
    },
    {
      path: 'dtg/daily',
      name: T('crew_menu::store_dtg_profit'),
      icon_html: html` <i class="d-block lnr lnr-chart-bars"></i> `,
    },
  ],
};

export const CONFIRMATIONS_MENU = {
  path: 'confirmations',
  name: T('crew_menu::confirmations'),
  icon_html: html` <i class="d-block lnr lnr-spell-check"></i> `,
  action_option: {
    actions: ACTION.UPDATE_PRODUCT_CONFIRM,
    target: ACTION_TARGET.CREW,
    service: SERVICE.CONFIRMATION,
    pass_no_service: false,
  },
};

export const SAMPLE_CHART_MENU = {
  path: 'chart',
  name: T('plus_admin::pa195'),
  icon_html: html` <i class="d-block lnr lnr-pie-chart"></i> `,
  action_option: {
    actions: ACTION.READ_MARPPLESHOP_ANALYTICS,
    target: ACTION_TARGET.CREW,
    service: SERVICE.ADMIN,
    pass_no_service: false,
  },
};

export const PRODUCT_LIST_MENU = {
  path: 'products/public?category=9',
  name: T('crew_menu::products'),
  icon_html: html` <i class="d-block lnr lnr-shirt"></i> `,
  action_option: {
    service: SERVICE.ADMIN,
    pass_no_service: false,
  },
  filter: isNotCategoryOutsourceManagerByCrew,
};

export const PRODUCT_CHECK_MENU = (count) => ({
  path: 'product/check',
  name: html`${T('crew_menu::product_check')}
  ${isNil(count) ? '' : html`<span class="menu_count">${count}</span>`}`,
  icon_html: html` <i class="d-block lnr lnr-eye"></i> `,
  action_option: {
    service: SERVICE.ADMIN,
    actions: ACTION.CAN_CHECK_DESIGN,
    target: ACTION_TARGET.CREW,
    pass_no_service: false,
  },
});

export const INSPECT_MENU = (count) => ({
  path: 'pb',
  name: html`${T('crew_menu::pb_inspect')}
  ${isNil(count) ? '' : html`<span class="menu_count">${count}</span>`}`,
  icon_html: html` <i class="d-block lnr lnr-checkmark-circle"></i> `,
  action_option: {
    service: SERVICE.PB,
    pass_no_service: false,
    target: ACTION_TARGET.CREW,
    actions: ACTION.CAN_CHECK_DESIGN,
  },
  sub_menus: [
    {
      path: 'list',
      name: T('crew_menu::inspect_list'),
      icon_html: html` <i class="d-block lnr lnr-screen"></i> `,
    },
    {
      path: 'inspect',
      name: T('crew_menu::inspect'),
      icon_html: html` <i class="d-block lnr lnr-screen"></i> `,
    },
  ],
});

export const DESIGN_THEME_INSPECT_MENU = (count) => ({
  path: 'design-theme-inspect',
  name: html`크리에이터 디자인 검수 ${isNil(count) ? '' : html`<span class="menu_count">${count}</span>`}`,
  icon_html: html` <i class="d-block design-theme-icon">${designThemeIcon({ html })}</i> `,
  action_option: {
    service: SERVICE.ADMIN,
    pass_no_service: false,
    target: ACTION_TARGET.CREW,
    actions: ACTION.CAN_CHECK_DESIGN,
  },
});

// export const SELLER_TIP_MENU = {
//   path: 'feeds',
//   name: T('crew_menu::feeds'),
//   icon_html: html`<i class="d-block lnr lnr-bubble"></i>`,
//   action_option: {
//     actions: ACTION.CREATE_FEED,
//     target: ACTION_TARGET.CREW,
//   },
// };

export const SOLUTION_MENU = {
  path: UtilS.isMarppleShopApp() ? ADMIN_LNB_MENU_ID.SOLUTION : 'solution/list?status=ing2',
  name: T('crew_menu::solution'),
  icon_html: html` <i class="d-block lnr lnr-heart"></i> `,
  action_option: {
    service: SERVICE.ADMIN,
    pass_no_service: false,
  },
  filter: isNotCategoryOutsourceManagerByCrew,
};

export const CREW_WITHDRAW_MENU = {
  path: 'crew_withdraws',
  name: T('crew_menu::crew_withdraw'),
  icon_html: html` <i class="d-block lnr lnr-diamond big"></i> `,
  action_option: {
    service: SERVICE.WITHDRAW,
    pass_no_service: false,
    actions: ACTION.READ_CREW_WITHDRAWS,
    target: ACTION_TARGET.CREW,
  },
  filter: (crew) => {
    return isAllOrMarppleCrewById(crew.id);
  },
};

export const CREW_WITHDRAW_V2_MENU = {
  path: 'withdraws_v2',
  name: ET('mps2::seller_studio::navigation::product_adjustments'),
  icon_html: html` <i class="d-block lnr lnr-diamond big"></i> `,
  action_option: {
    service: SERVICE.WITHDRAW,
    pass_no_service: false,
    actions: ACTION.REQUEST_CREW_WITHDRAWS,
    target: ACTION_TARGET.CREW,
  },
};

export const CREW_BANK_ACCOUNT_MENU = {
  path: 'crew_bank_account',
  name: T('crew_menu::crew_bank_account'),
  icon_html: html` <i class="d-block lnr lnr-license"></i> `,
  action_option: {
    service: SERVICE.WITHDRAW,
    pass_no_service: false,
    actions: ACTION.REGISTER_CREW_BANK_ACCOUNT,
    target: ACTION_TARGET.CREW,
  },
};

export const CREW_YOUTUBE_MENU = {
  path: 'youtube_list',
  name: T('crew_menu::crew_youtube'),
  icon_html: html` <i class="d-block youtube-icon"></i> `,
  action_option: {
    service: SERVICE.ADMIN,
    pass_no_service: false,
  },
  filter: isNotCategoryOutsourceManagerByCrew,
};

const is_ness = UtilS.isNessApp();
export const SITE_MANAGE_MENU = {
  path: 'website',
  name: T('crew_menu::website'),
  icon_html: html` <i class="d-block lnr lnr-store big" style="margin-top: -4px;"></i> `,
  action_option: {
    actions: ACTION.MANAGE_SITE,
    target: ACTION_TARGET.CREW,
  },
  sub_menus: [
    {
      path: 'brand',
      name: is_ness ? ET('ness::plus_admin::pa_001') : T('plus_admin::pa402'),
      icon_html: html` <i class="d-block lnr lnr-screen"></i> `,
    },
    /*{
      path: 'title',
      name: '타이틀 관리',
      icon_html: html` <i class="d-block lnr lnr-screen"></i> `,
    },*/
    {
      path: 'banner',
      name: T('plus_admin::pa422'),
      icon_html: html` <i class="d-block lnr lnr-screen"></i> `,
      is_all_crew: true,
    },
    {
      path: 'banner',
      name: ET('mps2::plus_studio::banner::title'),
      icon_html: html` <i class="d-block lnr lnr-screen"></i> `,
      is_all_crew: false,
    },
    {
      path: 'creator-sort',
      name: ET('mps2::plus_studio::creator::sort::title'),
      icon_html: html` <i class="d-block lnr lnr-screen"></i> `,
      is_all_crew: false,
    },
    {
      path: 'live',
      name: T('plus_admin::pa515'),
      icon_html: html` <i class="d-block lnr lnr-screen"></i> `,
      is_all_crew: true,
    },
    // {
    //   path: 'seller',
    //   name: '메인 셀러 관리',
    //   icon_html: html` <i class="d-block lnr lnr-screen"></i> `,
    // },
    // {
    //   path: 'styles',
    //   name: T('plus_admin::pas690'),
    //   icon_html: html` <i class="d-block lnr lnr-screen"></i> `,
    //   is_all_crew: true,
    // },

    ...(is_ness
      ? [
          {
            path: 'brandedcontents',
            name: '브랜디드 컨텐츠',
          },
          {
            path: 'events',
            name: T('plus_admin::pa470-1'),
            icon_html: html` <i class="d-block lnr lnr-screen"></i> `,
          },
        ]
      : [
          {
            path: 'creator_views',
            name: T('plus_admin::pa470-3'),
            icon_html: html` <i class="d-block lnr lnr-screen"></i> `,
            is_all_crew: true,
          },
          {
            path: 'popup-stores',
            name: T('plus_admin::pa712'),
            icon_html: html` <i class="d-block lnr lnr-screen"></i> `,
            is_all_crew: true,
          },
          {
            path: 'curations',
            name: T('plus_admin::pa470-2'),
            icon_html: html` <i class="d-block lnr lnr-screen"></i> `,
            is_all_crew: true,
          },
          {
            path: 'events',
            name: T('plus_admin::pa470'),
            icon_html: html` <i class="d-block lnr lnr-screen"></i> `,
            is_all_crew: false,
          },
          {
            path: 'popup',
            name: T('plus_admin::pa470-4'),
            icon_html: html` <i class="d-block lnr lnr-screen"></i> `,
            is_all_crew: true,
          },
        ]),
    // {
    //   path: 'product',
    //   name: T('plus_admin::pa501'),
    //   icon_html: html` <i class="d-block lnr lnr-screen"></i> `,
    // },
    {
      path: 'live',
      name: is_ness ? ET('ness::plus_admin::pa_068') : ET('ness::plus_admin::pa_068'),
      icon_html: html` <i class="d-block lnr lnr-screen"></i> `,
      is_all_crew: false,
    },
    ...(is_ness
      ? []
      : [
          {
            path: 'popup',
            name: T('plus_admin::pa470-4'),
            icon_html: html` <i class="d-block lnr lnr-screen"></i> `,
            is_all_crew: false,
          },
        ]),
  ],
};

export const MENU_SPLITER = {
  html: '<div class="menu_spliter"></div>',
};
